module.exports = __webpack_public_path__ + "media/images/client-24-8d188617872bad010a487e7f3661d114.png";